// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__3Kj_H","label":"Labeled_label__K035G","divider":"Labeled_divider__1Mlwu"};